<nav class="navbar navbar-expand-sm fabrilHeader fixed-top d-print-none">
  <div class="container-fluid">
        <span (click)="toggleNavbar()" [ngClass]="{'mySidenav.style.width': this._plantilla.variable}"
              [style.marginLeft]="this._plantilla.variable"
              style="font-size:30px; cursor:pointer; margin-left: 15px;"> &#9776; Fabril</span>
    <button aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
            data-bs-target="#navbarScroll" data-bs-toggle="collapse" type="button">
      <i class="fa fa-cog"></i>
    </button>

    <div class="collapse navbar-collapse" id="navbarScroll">
      <ul class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll"></ul>
      <ul class="nav navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a class="nav-link nav-profile d-flex align-items-center pe-0" data-bs-toggle="dropdown" href="#">
            <img alt="Profile" class="rounded-circle" height="35" src="../../../../assets/images/logo/user-svg.svg"
                 width="35">
            <span class="d-none d-md-block dropdown-toggle ps-2" id="nombreUsuario">{{ nombreUsuario }}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
            <li class="dropdown-header">
              <h6>{{nombreUsuario}}</h6>
              <!-- <span>Ing. Software</span> -->
            </li>
            <!-- <li>
                    <hr class="dropdown-divider">
                </li> -->

            <!-- <li>
                    <a class="dropdown-item d-flex align-items-center" href="users-profile.html">
                        <i class="bi bi-person"></i>
                        <span>My Profile</span>
                    </a>
                </li> -->
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <a (click)="onLogout()" class="dropdown-item">
                <i class="bi bi-box-arrow-right"></i>
                <span>Cerrar sesion</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
